import React from 'react';

const EmailSidebar = ({ selectedFolder, onFolderChange, onCompose, emailCounts }) => {
  const folders = [
    { id: 'inbox', name: 'Caixa de Entrada', icon: 'fa-inbox' },
    { id: 'sent', name: 'Enviados', icon: 'fa-paper-plane' },
    { id: 'drafts', name: 'Rascunhos', icon: 'fa-file-alt' },
    { id: 'starred', name: 'Com estrela', icon: 'fa-star' },
    { id: 'trash', name: 'Lixeira', icon: 'fa-trash' },
  ];

  return (
    <div className="email-sidebar">
      <button className="compose-btn" onClick={onCompose}>
        <i className="fas fa-edit"></i>
        Escrever
      </button>
      
      <div className="folder-list">
        {folders.map(folder => (
          <div
            key={folder.id}
            className={`folder-item ${selectedFolder === folder.id ? 'active' : ''}`}
            onClick={() => onFolderChange(folder.id)}
          >
            <i className={`fas ${folder.icon}`}></i>
            <span className="folder-name">{folder.name}</span>
            {folder.id === 'inbox' && emailCounts.inbox > 0 && (
              <span className="unread-count">{emailCounts.inbox}</span>
            )}
          </div>
        ))}
      </div>
      
      <div className="sidebar-footer">
        <div className="storage-info">
          <div className="storage-bar">
            <div className="storage-used" style={{ width: '35%' }}></div>
          </div>
          <span className="storage-text">3.5 GB de 15 GB usados</span>
        </div>
      </div>
    </div>
  );
};

export default EmailSidebar;